var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fullScreenLoading from './fullScreenLoading';
export default function tryWithFullscreenLoading(fn, message) {
    return __awaiter(this, void 0, void 0, function* () {
        const loading = fullScreenLoading;
        const start = Date.now();
        const getElaspedTime = () => {
            const end = Date.now();
            const elapsedTime = (end - start) / 1000;
            return elapsedTime.toFixed(0);
        };
        const getDisplayMessage = () => `${message || ''} Elapsed time: ${getElaspedTime()} seconds`;
        const getHtmlDisplayMessage = () => `${message || ''} <br> Elapsed time: ${getElaspedTime()} seconds`;
        // Start a periodic update of the loading message.
        const timer = setInterval(() => {
            loading.hide();
            loading.show({
                message: getDisplayMessage(),
                htmlMessage: getHtmlDisplayMessage()
            });
        }, 500);
        try {
            loading.show({
                message: getDisplayMessage(),
                htmlMessage: getHtmlDisplayMessage()
            });
            const result = yield fn();
            clearInterval(timer);
            loading.hide();
            return result;
        }
        catch (e) {
            console.error(e);
            clearInterval(timer);
            loading.hide();
            return undefined;
        }
    });
}
